import React from 'react';
import { useTranslation } from 'react-i18next';
import './ProjectDropdown.css';

// ProjectDropdown picks the finance project a transaction belongs to
// (Trello DdqnIHsy). The value is the project's _id; "" means no project.
// Pass projects in (from /api/finance/projects) — a list of transactions
// loads them once instead of once per row. Only active projects are
// offered, plus the currently selected one if it has since been closed, so
// an existing tag still shows its name. Other props (name, onChange,
// defaultValue…) go straight to the <select>.
export const ProjectDropdown = ({ projects, selected, className, ...selectProps }) => {
  const { t } = useTranslation();
  const options = (projects || []).filter(p => p.status !== 'closed' || p._id === selected);

  return (
    <select {...selectProps} className={`project-dropdown ${className || ''}`.trim()}
      {...(selected !== undefined ? { value: selected || '' } : {})}>
      <option value="">{t('no_project')}</option>
      {options.map(p => (
        <option key={p._id} value={p._id}>{p.code} — {p.name}</option>
      ))}
    </select>
  );
};

export default ProjectDropdown;
